import React from 'react'

import { TbUnderline } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { MarkButton } from '@app/lib/inputs/RichEditor/marks/MarkButton'

export const MarkUnderlineButton = () => {
  const { formatMessage } = useIntl()

  return (
    <MarkButton
      format='Underline'
      icon={<TbUnderline />}
      aria-label={formatMessage({ id: 'RichEditor.Mark.Underline' })}
    />
  )
}
